"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldType = exports.getPattern = exports.getPlaceholder = exports.getIconName = exports.isHiddenField = exports.fillFieldDataFromRegistry = void 0;
const types_1 = require("@smartsuite/types");
const fields_logic_registry_1 = require("./fields-logic-registry");
/**
 * returns application field with icon, placeholder and parent data
 *
 * @param fields             application fields list.
 * @param parent             application field slug.
 *
 * @example
 *
 * fillFieldDataFromRegistry(fields)
 * fillFieldDataFromRegistry(fields, parent)
 */
const fillFieldDataFromRegistry = (fields = [], parent) => {
    return fields
        .filter((field) => !(0, exports.isHiddenField)(field))
        .map((field) => {
        var _a;
        const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
        const nested = field.params.nested
            ? fieldLogic === null || fieldLogic === void 0 ? void 0 : fieldLogic.getNestedFields(field)
            : [];
        return {
            ...field,
            parent,
            nested: [...(0, exports.fillFieldDataFromRegistry)(nested, field)],
            disabled: false,
            icon: (0, exports.getIconName)(field),
            placeholder: (0, exports.getPlaceholder)(field),
            pattern: (_a = (0, exports.getPattern)(field)) !== null && _a !== void 0 ? _a : undefined,
        };
    });
};
exports.fillFieldDataFromRegistry = fillFieldDataFromRegistry;
/**
 * returns True if field is hidden
 *
 * @param field     application structure field.
 *
 * @example
 *
 * isHiddenField("textareafield")
 */
const isHiddenField = (field) => {
    return (field.field_type.includes("hidden_") ||
        types_1.hiddenFields.includes(field.field_type) ||
        Boolean(field.params.hidden));
};
exports.isHiddenField = isHiddenField;
/**
 * Returns field icon name
 */
const getIconName = (field) => {
    const fieldType = (0, fields_logic_registry_1.getFieldLogic)(field === null || field === void 0 ? void 0 : field.field_type);
    return fieldType === null || fieldType === void 0 ? void 0 : fieldType.icon;
};
exports.getIconName = getIconName;
/**
 * Returns field placeholder
 */
const getPlaceholder = (field) => {
    const fieldType = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return fieldType === null || fieldType === void 0 ? void 0 : fieldType.placeholder;
};
exports.getPlaceholder = getPlaceholder;
/**
 * Returns field pattern
 */
const getPattern = (field) => {
    var _a;
    const fieldType = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return (_a = fieldType.pattern) !== null && _a !== void 0 ? _a : null;
};
exports.getPattern = getPattern;
const getFieldType = (field) => {
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
    return fieldLogic.getFieldType(field);
};
exports.getFieldType = getFieldType;
